export const cycle_round = (cycle: number) => {
  if (cycle < 1) {
    return 1
  } else if (cycle < 2) {
    return 2
  } else if (cycle < 4) {
    return 4
  } else {
    return 8
  }
}
